/* unplugin-vue-components disabled */import script from "./galleryDesc.vue?vue&type=script&setup=true&lang=js"
export * from "./galleryDesc.vue?vue&type=script&setup=true&lang=js"

import "./galleryDesc.vue?vue&type=style&index=0&id=f139c34c&scoped=true&lang=scss"

import exportComponent from "/Users/admin/Desktop/project/klb/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f139c34c"]])

export default __exports__